import classnames from "classnames";
import { ColumnInstance, HeaderGroup as HeaderGroupType } from "react-table";
import { genericMemo } from "../../../../../../utils";
import { Column } from "../../../TableContainer";
import { TableFooterContext } from "../contexts/TableFooterContext";

import styles from "../style.module.scss";

type FooterCellProps<T extends object> = { column: HeaderGroupType<T> & { footerAccessor?: (footerData: any, column: ColumnInstance<T>) => any } };

const FooterCell = genericMemo(
  <T extends object>({ column, ...restProps }: FooterCellProps<T>) => {
    const { className, style, ...cellProps } = column.getFooterProps();

    const declaredColumn = (column as Column<T>);
    const declaredCellProps = declaredColumn?.getCellProps?.(undefined, "footer");

    return (
      <div
        {...cellProps}
        {...declaredCellProps}
        style={{
          ...style,
          ...declaredCellProps?.style,
          minWidth: column.minWidth,
        }}
        className={classnames(
          className,
          styles.cell,
          styles.footerCell,
          { [styles.selectionCell]: (column as Column<T>).freezeOnScroll },
          declaredCellProps?.className,
        )}
      >
        <TableFooterContext.Consumer>
          {
            (footerData) =>
              column.render("Footer", {
                footerValue: column.footerAccessor?.(footerData, column),
                footerData,
              })
          }
        </TableFooterContext.Consumer>
      </div>
    );
  },
);

export default FooterCell;
